<form [formGroup]="cvParseForm" name="cvParseForm" novalidate>
<h4 mat-dialog-title>
  <span>
    Parse CV
  </span>
  <button
    (click)="closeDialog()"
    class="close-btn"
    data-test-id="cv-parse-dialog-close-button"
    isIconButton="true"
    mat-button
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</h4>
  <mat-dialog-content class="flex flex-col flex-start-start pb-24" data-test-id="cv-parse-dialog-content">
    <p>Upload your PDF to automatically generate and complete your CV. This process may take a few minutes.</p>
    <div class="cv-parse-infobox w-full relative">
      <mat-icon svgIcon="tooltip_info_default"></mat-icon>
      <p class="font-bold mt-0 mb-8">Best Parsing results achieved when:</p>
      <ul color="primary">
        <li><span class="icon list-element-circle"></span>Your PDF contains selectable text (not just a scanned image).</li>
        <li><span class="icon list-element-circle"></span>Sections are clearly labeled (e.g., “Work Experience”, “Education”, “Skills”).</li>
        <li><span class="icon list-element-circle"></span>Layout is straightforward — minimal columns, tables, graphics, or heavy styling.</li>
      </ul>
    </div>
    <validation-messages
        [field]="cvToParseControl"
        [messages]="['fileSizeLimit', 'fileExtension', 'fileMimeType']"
        [texts]="{
          fileSizeLimit: 'PDF size can\n’t be more than ' + CV_FILE_MAX_SIZE + 'MB.',
          fileExtension: 'Please upload a ' + CV_VALID_FILE_EXT.join(', ').toLowerCase() + ' file. Other formats are not supported.',
          fileMimeType: 'Please upload a ' + CV_VALID_FILE_EXT.join(', ').toLowerCase() + ' file. Other formats are not supported.',
        }"
        data-test-id="cv-parse-dialog-validationMessages"
    ></validation-messages>
  </mat-dialog-content>
  <mat-dialog-actions align="start" class="pt-16">
    <section [formGroup]="cvParseForm" class="cv-parse-box">
      <cv-parse-control data-test-id="form-cv-parse-UploadedFiles" formControlName="cvToParse"></cv-parse-control>
    </section>
    <button
      (click)="closeDialog()"
      color="primary"
      data-test-id="cv-parse-dialog-cancel-button"
      mat-button
      type="button"
    >
      Cancel
    </button>
  </mat-dialog-actions>
</form>